export default __webpack_public_path__ + "static/media/ic_file.19bc6273.svg";